import { call, select } from 'redux-saga/effects';
import { redeemCampaign as redeemCampaignAda } from '@gcloud-npm/adabyron.misc.redeem-campaign';

const contextStore = state => state.context.data;

export function* redeemCampaign(params) {

  const context = yield select(contextStore);
  const response = yield call(redeemCampaignAda, { data: params, context });
  return response;
}
